var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-input-row"},[_c('app-label',[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),_vm._t("label-content",function(){return [_c('app-label-content',[_vm._t("default")],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }